import Result from './Result';
import SearchInput from './SearchInput';
import styles from './style.m.less';

export default function HeaderSearchBar({ items, showResults, onFocus, onBlur }) {
    return (
        <div className={styles.container} id="header_search_bar">
            <SearchInput items={items} onFocus={onFocus} onBlur={onBlur} />
            {showResults ? <Result onFocus={onFocus} onBlur={onBlur} /> : <noscript />}
        </div>
    );
}
